// extracted by mini-css-extract-plugin
export default {"Label":"voisesettingsitem_Label__WtFFR","Descriptions":"voisesettingsitem_Descriptions__IZLAk"};